<div *ngIf="spinner==true">
  <ngx-spinner size="medium" type="timer">
    <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
  </ngx-spinner>
</div>
<div class="container-fluid">
  <div class="card shadow">
     <div class="card-header">
          <div class="d-flex justify-content-between" id="table-to-print">
            <h4 class="font-weight-bold text-dark py">DISTRICT ADMIN ADDRESS REPORT</h4>
          </div>
      </div>
      <div>
        <button class="btn btn-default" id="printButton" (click)="printPage()">Print</button>
      </div>
      <!-- DISTRICT ADMIN DATATABLE         -->
      <div class="wrapper" >
        <div class="card-body">
            <div class="table-responsive" *ngIf="tableshow" >
                <!-- TABLE -->
                <div id="table-to-print">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable 
                    cellspacing="0">
                    <thead>
                        <tr>
                          <!-- <th>District</th> -->
                            <!-- <th>District Admin Name</th> -->
                            <!-- <th>Mobile Number</th> -->
                            <th>Address</th>
                            <!-- <th>Street Name</th>
                            <th>Town/city</th>
                            <th>Taluk</th>
                            <th>Pincode</th> -->
                            <!-- <th>No. of Office Bearer</th>                             -->

                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers[0]">
                          <!-- <td style="min-width: 20px;">
                            {{customer.district}}
                        </td> -->
                            <!-- <td style="min-width: 20px;">
                                {{customer.name}}
                            </td>                             -->
                            <!-- <td style="min-width: 20px;">
                                {{customer.approval_status}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                              {{customer.contact_no}}

                            </td> -->
                            <td style="min-width: 0; white-space: pre-line;" >  
                          <strong>District Admin Name:</strong>{{customer.name}}<br>                            
                          <strong>Door/Flat No:</strong> {{customer.flat_no}}<br>
                          <strong>Address:</strong>  {{customer.address1}}<br>
                          <strong>Town/City: </strong> {{customer.town_city}}<br>
                          <strong>Taluk:</strong>{{customer.taluk}}<br>
                          <strong>District:</strong>{{customer.district}}<br>
                          <strong>Pincode:</strong>{{customer.pincode}}<br>
                          <strong>Mobile Number:</strong>{{customer.contact_no}}<br>

                            </td>
                            <!-- <td style="min-width: 20px;">
                            {{customer.address1}}
                            </td>
                            <td style="min-width: 20px;">
                              {{customer.town_city}}
                            </td>
                            <td style="min-width: 20px;">
                              {{customer.taluk}}
                            </td>
                            <td style="min-width: 20px;">
                              {{customer.pincode}}
                            </td> -->
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        </div>
      </div>
      
        <footer >
          <div class="footclass">
          <p >DMK Engineers Wing</p>
        </div>
        </footer>
    </div>